import { useState, useEffect, useCallback } from 'react';

const useWakeLock = () => {
  const [wakeLockSupported, setWakeLockSupported] = useState(false);
  const [wakeLock, setWakeLock] = useState(null);

  const requestWakeLock = useCallback(async () => {
    try {
      if ('wakeLock' in navigator) {
        setWakeLockSupported(true);
        const lock = await navigator.wakeLock.request('screen');
        setWakeLock(lock);
        
        lock.addEventListener('release', () => {
          setWakeLock(null);
        });
      } else {
        const keepAwake = async () => {
          try {
            if ('keepAwake' in window.screen) {
              await window.screen.keepAwake();
              setWakeLockSupported(true);
            }
          } catch (error) {
            console.log('Dispositivo não suporta keepAwake');
          }
        };
        
        keepAwake();
      }
    } catch (err) {
      console.log('Wake Lock não suportado neste dispositivo');
    }
  }, []);

  const releaseWakeLock = useCallback(() => {
    if (wakeLock) {
      wakeLock.release();
      setWakeLock(null);
    }
  }, [wakeLock]);

  useEffect(() => {
    requestWakeLock();

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        requestWakeLock();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      releaseWakeLock();
    };
  }, [requestWakeLock, releaseWakeLock]);

  return { 
    isSupported: wakeLockSupported,
    isActive: !!wakeLock 
  };
};

export default useWakeLock;